module.exports = __webpack_public_path__ + "img/icon_nonpresente.cf46b38d.png";